module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAABGdBTUEAALGPC/xhBQAAAO5JREFUWAntmDESgkAMRTe4egAbhtE72DpWnMpDcBGuQcXYegeVsfEAAsZEmgxktHLZIqk+fxjy94VmA45qc8Jt92oL5yB3DjP2whU01LPyyfJ43cMFOEyP3RkR1+FCTDsBwGMBfucHMm7WMByPgXTYFskwpmnieRzIKVDof+bbUTGjQHGVBfo1Dz9+4X5Ywdj753NaP1F+30YmaWjaCGlUpGeEJA1NGyGNivSMkKShaSOkUZGeEZI0NG2ENCrSM0KShqajIwRp3d7iuZtBQ4Sw0tDN42EV3bIh4RUIbx2ISEn3fFqNhK5Pz5IzcJY32xNA28utOW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/Components/Specialties/img/web.png
// module id = 143
// module chunks = 0